import React, { useEffect, useState } from 'react';

import styles from './OffspringDisplay.module.scss';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

function OffspringDisplay(props: OffspringDisplayProps) {
    const t = useTranslate();

    const [displayOwner, setDisplayOwner] = useState<Array<number>>([]);

    const [noprintFields, setNoprintFields] = useState<Array<string>>([]);

    const resultFormatter = (result: any) => {
        return {
            ...result,
            offspring: {
                ...result.offspring,
                HDSNITT_FORELDRE: result.offspring.HDSNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.HDSNITT_FORELDRE,
                GLAUKOM: result.offspring.GLAUKOM_HASNULL > 0 ? "" : result.offspring.GLAUKOM, // Is this hiding correct? 
                M1_EBV_LOS_SNITT_FORELDRE: result.offspring.M1_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M1_EBV_LOS_SNITT_FORELDRE,
                M2_EBV_LOS_SNITT_FORELDRE: result.offspring.M2_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M2_EBV_LOS_SNITT_FORELDRE,
                M3_EBV_LOS_SNITT_FORELDRE: result.offspring.M3_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M3_EBV_LOS_SNITT_FORELDRE,
                M4_EBV_LOS_SNITT_FORELDRE: result.offspring.M4_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M4_EBV_LOS_SNITT_FORELDRE,
                M5_EBV_LOS_SNITT_FORELDRE: result.offspring.M5_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M5_EBV_LOS_SNITT_FORELDRE,
                M6_EBV_LOS_SNITT_FORELDRE: result.offspring.M6_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M6_EBV_LOS_SNITT_FORELDRE,
                M7_EBV_LOS_SNITT_FORELDRE: result.offspring.M7_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M7_EBV_LOS_SNITT_FORELDRE,
                M8_EBV_LOS_SNITT_FORELDRE: result.offspring.M8_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M8_EBV_LOS_SNITT_FORELDRE,
                M9_EBV_LOS_SNITT_FORELDRE: result.offspring.M9_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M9_EBV_LOS_SNITT_FORELDRE,
                M10_EBV_LOS_SNITT_FORELDRE: result.offspring.M10_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M10_EBV_LOS_SNITT_FORELDRE,
                M10A_EBV_LOS_SNITT_FORELDRE: result.offspring.M10A_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M10A_EBV_LOS_SNITT_FORELDRE,
                M10B_EBV_LOS_SNITT_FORELDRE: result.offspring.M10B_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M10B_EBV_LOS_SNITT_FORELDRE,
                M10C_EBV_LOS_SNITT_FORELDRE: result.offspring.M10C_EBV_LOS_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M10C_EBV_LOS_SNITT_FORELDRE,
                M1_EBV_BAND_SNITT_FORELDRE: result.offspring.M1_EBV_BAND_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M1_EBV_BAND_SNITT_FORELDRE,
                M2_EBV_BAND_SNITT_FORELDRE: result.offspring.M2_EBV_BAND_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M2_EBV_BAND_SNITT_FORELDRE,
                M3_EBV_BAND_SNITT_FORELDRE: result.offspring.M3_EBV_BAND_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M3_EBV_BAND_SNITT_FORELDRE,
                M4_EBV_BAND_SNITT_FORELDRE: result.offspring.M4_EBV_BAND_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M4_EBV_BAND_SNITT_FORELDRE,
                M5_EBV_BAND_SNITT_FORELDRE: result.offspring.M5_EBV_BAND_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.M5_EBV_BAND_SNITT_FORELDRE,
                JAKTLYST_RAB_SNITT_FORELDRE: result.offspring.JAKTLYST_RAB_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.JAKTLYST_RAB_SNITT_FORELDRE,
                SAMARBEID_RAB_SNITT_FORELDRE: result.offspring.SAMARBEID_RAB_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.SAMARBEID_RAB_SNITT_FORELDRE,
                FOTARBEID_RAB_SNITT_FORELDRE: result.offspring.FOTARBEID_RAB_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.FOTARBEID_RAB_SNITT_FORELDRE,
                MAALBRUK_FOT_RAB_SNITT_FORELDRE: result.offspring.MAALBRUK_FOT_RAB_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.MAALBRUK_FOT_RAB_SNITT_FORELDRE,
                MAALBRUK_TAP_RAB_SNITT_FORELDRE: result.offspring.MAALBRUK_TAP_RAB_SNITT_FORELDRE_HASNULL > 0 ? "" : result.offspring.MAALBRUK_TAP_RAB_SNITT_FORELDRE,
            }
        }
    }

    const excludeKeys = [
        // "OWNER_FIRST_NAME",
        // "OWNER_LAST_NAME",
        // "OWNER_PHONE",
        // "OWNER_EMAIL",
        "GLAUKOM_HASNULL",
        "HDSNITT_FORELDRE_HASNULL",
        "M1_EBV_LOS_SNITT_FORELDRE_HASNULL",
        "M2_EBV_los_snitt_foreldre_hasnull",
        "M3_EBV_los_snitt_foreldre_hasnull",
        "M4_EBV_los_snitt_foreldre_hasnull",
        "M5_EBV_los_snitt_foreldre_hasnull",
        "M6_EBV_los_snitt_foreldre_hasnull",
        "M7_EBV_los_snitt_foreldre_hasnull",
        "M8_EBV_los_snitt_foreldre_hasnull",
        "M9_EBV_los_snitt_foreldre_hasnull",
        "M10_EBV_los_snitt_foreldre_hasnull",
        "M10A_EBV_los_snitt_foreldre_hasnull",
        "M10B_EBV_los_snitt_foreldre_hasnull",
        "M10C_EBV_los_snitt_foreldre_hasnull",
        "M1_EBV_band_snitt_foreldre_hasnull",
        "M2_EBV_band_snitt_foreldre_hasnull",
        "M3_EBV_band_snitt_foreldre_hasnull",
        "M4_EBV_band_snitt_foreldre_hasnull",
        "M5_EBV_band_snitt_foreldre_hasnull",
        "JAKTLYST_RAB_SNITT_FORELDRE_HASNULL",
        "SAMARBEID_RAB_SNITT_FORELDRE_HASNULL",
        "FOTARBEID_RAB_SNITT_FORELDRE_HASNULL",
        "MAALBRUK_FOT_RAB_SNITT_FORELDRE_HASNULL",
        "MAALBRUK_TAP_RAB_SNITT_FORELDRE_HASNULL",
    ].map(key => key.toUpperCase());

    function drawPartnerHeaders() {
        let sex = props.selectedDog?.SEX;
        let headers = [];

        switch (sex) {
            case "male":
                props.results?.forEach((result: any) => {
                    headers.push(<th
                        key={result.dam?.REGNO}
                        onClick={() => {
                            if (displayOwner?.includes(result?.dam?.REGNO)) {
                                setDisplayOwner(displayOwner?.filter((regno: number) => regno !== result?.dam?.REGNO));
                            } else {
                                setDisplayOwner([...displayOwner, result?.dam?.REGNO]);
                            }
                        }}
                    >
                        <div
                            className={styles.doginfo}
                            style={{
                                display: displayOwner?.includes(result?.dam?.REGNO) ? "none" : "block"
                            }}
                        >
                            <p>{result?.dam?.REGNO}</p>
                            <p>{result?.dam?.NAME}</p>
                            <hr/>
                            <p>{t("breedsimulator.results.birthdate")}: {new Date(result?.dam?.DATE_BIRTH).toLocaleDateString("no-NB")}</p>
                            <p>{t("breedsimulator.results.color")}: {result?.dam?.COLOR}</p>
                            <p>{t("breedsimulator.results.postalcode")}: {result?.dam?.POSTAL_CODE}</p>
                        </div>
                        <div
                            className={styles.ownerinfo}
                            style={{
                                display: displayOwner?.includes(result?.dam?.REGNO) ? "block" : "none"
                            }}
                            onClick={() => {
                                if (displayOwner?.includes(result?.dam?.REGNO)) {
                                    setDisplayOwner(displayOwner?.filter((regno: number) => regno !== result?.dam?.REGNO));
                                } else {
                                    setDisplayOwner([...displayOwner, result?.dam?.REGNO]);
                                }
                            }}
                        >
                            { result?.offspring?.OWNER_FIRST_NAME == undefined && result?.offspring?.OWNER_LAST_NAME == undefined ?
                                <p>{t("breedsimulator.results.owner_not_found")}</p>
                            :
                                <>
                                    <p>
                                        {
                                            result?.offspring?.OWNER_LAST_NAME + 
                                            (result?.offspring?.OWNER_LAST_NAME && result?.offspring?.OWNER_FIRST_NAME ? ", " : "") +
                                            result?.offspring?.OWNER_FIRST_NAME
                                        }
                                    </p>
                                    <hr/>
                                    <p
                                        className={styles.ownerphone}
                                        onClick={async (evt) => {
                                            evt.stopPropagation();
                                            navigator.clipboard.writeText(result?.offspring?.OWNER_PHONE);
                                            let text = await t("breedsimulator.results.phone_copied");
                                            toast.success(text);
                                        }}
                                    >{t("breedsimulator.results.owner_phone")}: {result?.offspring?.OWNER_PHONE}</p>
                                    <p
                                        className={styles.owneremail}
                                        onClick={(evt) => {
                                            evt.stopPropagation();
                                            navigator.clipboard.writeText(result?.offspring?.OWNER_EMAIL);
                                            let text = t("breedsimulator.results.email_copied");
                                            toast.success(text);
                                        }}
                                    >{t("breedsimulator.results.owner_email")}: {result?.offspring?.OWNER_EMAIL}</p>
                                </>
                            }
                        </div>
                    </th>);
                });
                break;
            case "female":
                props.results?.forEach((result: any) => {
                    headers.push(<th
                        key={result.sire?.REGNO}
                        onClick={() => {
                            if (displayOwner?.includes(result?.sire?.REGNO)) {
                                setDisplayOwner(displayOwner?.filter((regno: number) => regno !== result?.sire?.REGNO));
                            } else {
                                setDisplayOwner([...displayOwner, result?.sire?.REGNO]);
                            }
                        }}
                    >
                        <div
                            className={styles.doginfo}
                            style={{
                                display: displayOwner?.includes(result?.sire?.REGNO) ? "none" : "block"
                            }}
                        >
                            <p>{result?.sire?.REGNO}</p>
                            <p>{result?.sire?.NAME}</p>
                            <hr/>
                            <p>{t("breedsimulator.results.birthdate")}: {new Date(result?.sire?.DATE_BIRTH).toLocaleDateString("no-NB")}</p>
                            <p>{t("breedsimulator.results.color")}: {result?.sire?.COLOR}</p>
                            <p>{t("breedsimulator.results.postalcode")}: {result?.sire?.POSTAL_CODE}</p>
                        </div>
                        <div
                            className={styles.ownerinfo}
                            style={{
                                display: displayOwner?.includes(result?.sire?.REGNO) ? "block" : "none"
                            }}
                            onClick={() => {
                                if (displayOwner?.includes(result?.sire?.REGNO)) {
                                    setDisplayOwner(displayOwner?.filter((regno: number) => regno !== result?.sire?.REGNO));
                                } else {
                                    setDisplayOwner([...displayOwner, result?.sire?.REGNO]);
                                }
                            }}
                        >
                            { result?.offspring?.OWNER_FIRST_NAME == undefined && result?.offspring?.OWNER_LAST_NAME == undefined ?
                                <p>{t("breedsimulator.results.owner_not_found")}</p>
                            :
                                <>
                                    <p>
                                        {
                                            result?.offspring?.OWNER_LAST_NAME + 
                                            (result?.offspring?.OWNER_LAST_NAME && result?.offspring?.OWNER_FIRST_NAME ? ", " : "") +
                                            result?.offspring?.OWNER_FIRST_NAME
                                        }
                                    </p>
                                    <hr/>
                                    <p
                                        className={styles.ownerphone}
                                        onClick={async (evt) => {
                                            evt.stopPropagation();
                                            navigator.clipboard.writeText(result?.offspring?.OWNER_PHONE);
                                            let text = await t("breedsimulator.results.phone_copied");
                                            toast.success(text);
                                        }}
                                    >{t("breedsimulator.results.owner_phone")}: {result?.offspring?.OWNER_PHONE}</p>
                                    <p
                                        className={styles.owneremail}
                                        onClick={(evt) => {
                                            evt.stopPropagation();
                                            navigator.clipboard.writeText(result?.offspring?.OWNER_EMAIL);
                                            let text = t("breedsimulator.results.email_copied");
                                            toast.success(text);
                                        }}
                                    >{t("breedsimulator.results.owner_email")}: {result?.offspring?.OWNER_EMAIL}</p>
                                </>
                            }
                        </div>
                    </th>);
                });
                break;
            default:
                headers.push(<th key={"partner"}>
                    {t("breedsimulator.results.partner")}
                </th>);
                break;
        }
        return headers;
    }

    function getResultsByKey(key: string){
        let subresults: Array<any> = [];
        props.results?.forEach((result: any, index: any) => {
            subresults.push(<td key={index}>{resultFormatter(result).offspring[key]}</td>);
        });
        return subresults;
    }

    function drawTraits() {
        return Object.keys(props.results[0]?.offspring).map((key: any, index: any) => {
            if (!excludeKeys.includes(key)) {
                // if none of the results have a value for this key, return null
                let hasValue = false;
                props.results?.forEach((result: any) => {
                    if (resultFormatter(result).offspring[key] !== null && resultFormatter(result).offspring[key] !== "") {
                        hasValue = true;
                    }
                });
                if (!hasValue) {
                    return null;
                }

                if (!key.includes("SPACER")) {
                    return (
                        <tr key={index} className={noprintFields.includes(key) ? styles.noprint : ""}>
                            <td>{t("breedsimulator.results.traits." + key)}</td>
                            {getResultsByKey(key)}
                            <td
                                className={styles.eyebutton}
                            >
                                <button
                                    onClick={() => {
                                        if (noprintFields.includes(key)) {
                                            setNoprintFields(noprintFields.filter((field: string) => field !== key));
                                        } else {
                                            setNoprintFields([...noprintFields, key]);
                                        }
                                    }}
                                >
                                    {!noprintFields.includes(key) ?
                                        <i className="fas fa-eye"></i>
                                    :
                                        <i className="fas fa-eye-slash"></i>
                                    }
                                </button>
                            </td>
                        </tr>
                    );
                } else {
                    let nextKey = Object.keys(props.results[0]?.offspring)[index + 1];
                    let nextKeyHasValue = false;
                    props.results?.forEach((result: any) => {
                        if (resultFormatter(result).offspring[nextKey] !== null && resultFormatter(result).offspring[nextKey] !== "") {
                            nextKeyHasValue = true;
                        }
                    });

                    return <tr className={noprintFields.includes(key) ? styles.noprint : ""}>
                        <td
                            colSpan={props.results?.length + 1}
                            style={{
                                height: "20px",
                                paddingTop: "20px",
                                fontWeight: '800',
                                backgroundColor: "transparent",
                                display: nextKeyHasValue ? "table-cell" : "none"
                            }}
                        >
                            {key.slice(9,key.length)}
                        </td>
                        <td
                            className={styles.eyebutton}
                            style={{
                                display: nextKeyHasValue ? "table-cell" : "none"
                            }}
                        >
                            <button
                                onClick={() => {
                                    if (noprintFields.includes(key)) {
                                        setNoprintFields(noprintFields.filter((field: string) => field !== key));
                                    } else {
                                        setNoprintFields([...noprintFields, key]);
                                    }
                                }}
                            >
                                {!noprintFields.includes(key) ?
                                    <i className="fas fa-eye"></i>
                                :
                                    <i className="fas fa-eye-slash"></i>
                                }
                            </button>
                        </td>
                    </tr>
                }
            } else {
                return null;
            }
        });
    }


    function getSpacer(key: string) {
        let subresults: Array<any> = [];
        subresults.push(
            <tr>
            <td
                colSpan={props.results?.length + 1}
                style={{
                    height: "20px",
                    backgroundColor: "transparent"
                }}
            ></td>
            </tr>
        )

        subresults.push(
            <tr>
            <td
                colSpan={props.results?.length + 1}
                style={{
                    height: "20px",
                    backgroundColor: "transparent"
                }}
            ><b>{capitalizeFirstLetter(key.split("_").pop()!)}</b></td></tr>
        )

        return subresults;
    }

    const capitalizeFirstLetter = (string: string) => {
        if (!string) return string; // Handle empty strings
        string = string.toLowerCase();
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    return (
        <div className={styles.offspring}>
            <table>
                <thead>
                <tr>
                    <th>
                        <div className={styles.titlecontainer}>
                            {t("breedsimulator.results.partnerstitle")}
                            <hr/>
                                {t("breedsimulator.results.traitstitle")}
                            </div>
                        </th>
                        {drawPartnerHeaders()}
                    </tr>
                </thead>
                <tbody>
                    {drawTraits()}
                </tbody>
            </table>
        </div>
    );
}

class OffspringDisplayProps {
    results: any;
    selectedDog: any;
}

export default OffspringDisplay;
